// components/ScrollToTop.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Si pas d'ancre dans l'URL, scroll vers le haut
    if (!hash) {
      window.scrollTo(0, 0);
    }
    // Si il y a une ancre, gérer le scroll vers la section
    else {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        // Petit délai pour laisser le temps au DOM de se charger
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;